import { render } from "./ContentCategoriesList.vue?vue&type=template&id=70af2ffb&ts=true"
import script from "./ContentCategoriesList.vue?vue&type=script&lang=ts"
export * from "./ContentCategoriesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Contents/Categories/ContentCategoriesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70af2ffb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70af2ffb', __exports__)) {
    api.reload('70af2ffb', __exports__)
  }
  
  module.hot.accept("./ContentCategoriesList.vue?vue&type=template&id=70af2ffb&ts=true", () => {
    api.rerender('70af2ffb', render)
  })

}


export default __exports__